import React from "react";
import DialogConfirmButtons from "../../../../common/dialogConfirmButtons/DialogConfirmButtons";
import SuccessMessage from "../../../../messages/SuccessMessage";

const MfaEnrollmentsDeletedStep = ({ busy, user, onCompleted }) => {
  const onDoneClicked = () => {
    onCompleted();
  };

  const buttons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnEnabled={true}
      confirmBtnLabel="Done"
      onConfirm={onDoneClicked}
      omitCancelBtn={true}
    />
  );

  return (
    <div id="email-changed-step">
      <div className="reset-mfa-enrollment-step-body">
        <SuccessMessage
          className="email-access-verified-success-message"
          message={`MFA enrollments for ${user?.email} has been deleted.`}
        />
      </div>
      {buttons}
    </div>
  );
};

export default MfaEnrollmentsDeletedStep;
